import React, { ReactElement } from 'react'
import classNames from 'classnames'
import { gsap } from 'gsap'
import { useMediaQuery } from 'react-responsive'
import { Fancybox as NativeFancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

interface Props {
  content?: string
  children?: ReactElement | string
  className?: string
}

const wrapElements = (
  parent: HTMLElement,
  selectors: string[],
  className = 'wrapped-element'
) => {
  selectors.forEach((selector) => {
    parent.querySelectorAll(selector).forEach((el) => {
      const wrapper = document.createElement('div')

      wrapper.classList.add(className)
      wrapper.setAttribute('data-wrapped-element', selector)

      el.parentNode?.insertBefore(wrapper, el)
      wrapper.appendChild(el)
    })
  })
}

const handleGallery = (parent: HTMLElement, count: number) => {
  parent.querySelectorAll('.gallery').forEach((gallery) => {
    Array.from(gallery.children).forEach((child, index) => {
      gsap.set(child, { clearProps: 'display' })
      child.querySelector('.gallery__item-text')?.remove()

      if (gallery.children.length <= count) return

      if (index >= count) {
        gsap.set(child, { display: 'none' })
      } else if (index === count - 1) {
        const div = document.createElement('div')
        div.classList.add('gallery__item-text')
        div.innerHTML = `<p>Еще ${
          gallery.children.length - count
        } фотографий</p>`

        child.appendChild(div)
      }
    })
  })
}

const TextContent: React.FC<Props> = ({ content, className, children }) => {
  const elRef = React.useRef<HTMLDivElement>(null)
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)'
  })

  React.useEffect(() => {
    elRef.current?.querySelectorAll('.gallery').forEach((gallery: Element) => {
      NativeFancybox.bind(gallery as HTMLElement, 'a', {
        Carousel: {
          infinite: true
        },
        groupAll: true
      })
    })

    return () => {
      NativeFancybox.unbind(elRef.current)
      NativeFancybox.close()
    }
  })

  React.useEffect(() => {
    const el = elRef.current

    if (el) {
      wrapElements(el, [
        'table:not([class])',
        'video:not([class])',
        'iframe:not([class])'
      ])
    }
  }, [])

  React.useEffect(() => {
    const el = elRef.current
    if (el) {
      handleGallery(el, isMobile ? 3 : 4)
    }
  }, [isMobile])

  return (
    <div
      ref={elRef}
      className={classNames('text-content', className)}
      dangerouslySetInnerHTML={{
        __html: content ?? ''
      }}
    >
      {children}
    </div>
  )
}

export default TextContent
